import React from 'react';
import { Table, TableBody } from '@mui/material';
import UserTableHead from './components/UserTableHead.tsx';
import UserTableRow from './components/UserTableRow.tsx';

const UserTable =({
  users, 
  renderStates, 
  openMenu, 
  menuAnchorEl, 
  closeMenu, 
  openEdit, 
  handleDeleteUser,
  menuUserId 
} : {
  users: [{
    user_id: string;
    full_name: string;
    email: string;
    is_admin: boolean;
    last_login: string;
    states: string[];
  }];
  renderStates: (stateCodes: string[]) => string;
  openMenu: (event: React.MouseEvent<HTMLElement>, userId: string) => void;
  menuAnchorEl: HTMLElement | null;
  closeMenu: () => void;
  openEdit: (user: {
    user_id: string;
    full_name: string;
    email: string;
    is_admin: boolean;
    last_login: string;
    states: string[];
  }) => void;
  handleDeleteUser: (userId: string) => void;
  menuUserId: string | null;
}) => {
    return (
      <Table>
        <UserTableHead />
      <TableBody>
        {users.map((user) => (
          <UserTableRow
            key={user.user_id} 
            user={user} 
            renderStates={renderStates} 
            openMenu={openMenu} 
            menuAnchorEl={menuAnchorEl} 
            closeMenu={closeMenu} 
            openEdit={openEdit} 
            handleDeleteUser={handleDeleteUser} 
            menuUserId={menuUserId}
          />
        ))}
      </TableBody>
    </Table>
    );
}

export default UserTable;